import { JSX } from 'react';

// components
import { AtHeader } from '@/components/atoms/at-header/at-header';
import { AtText } from '@/components/atoms/at-text/at-text';

// types
import { IMlserviceLocationsProps } from './ml-service-locations.types';

/**
 * Renders a two-part contact block showing:
 * - Direct phone numbers for specific departments
 * - A list of design studios grouped by state
 *
 * This component is designed for the Contact Us page and is not intended for general reuse.
 * Phone numbers are replaced using Invoca's PNAPI on mount.
 *
 */

export const MlServiceLocations = ({
  otherDepartments,
  studios,
}: IMlserviceLocationsProps): JSX.Element => {
  return (
    <div className="container">
      {otherDepartments?.length && (
        <>
          <AtHeader className="h3-alt mb-8 text-skin-primary" element="h3">
            Call Us Directly
          </AtHeader>
          <div className="mb-14 grid grid-cols-1 md:grid-cols-4 md:gap-x-120 md:gap-y-8">
            {otherDepartments.map((department) => (
              <div key={department.department_name} className="mb-8">
                <AtHeader className="h4-sm mb-6 text-skin-primary" element="h4">
                  {department.department_name}
                </AtHeader>
                <AtText className="paragraph-md text-skin-primary">
                  {department.department_phone_number}
                </AtText>
              </div>
            ))}
          </div>
        </>
      )}
      <AtHeader className="h3-alt mb-8 text-skin-primary" element="h3">
        Design Studios
      </AtHeader>
      {Object.entries(studios).map(([state, studios]) => (
        <div key={state}>
          <AtHeader className="h4-sm mb-6 text-skin-primary" element="h4">
            {state}
          </AtHeader>
          <div className="mb-14 grid grid-cols-1 gap-y-8 md:grid-cols-4 md:gap-x-120">
            {studios.map((studio) => (
              <div key={studio.Id}>
                <AtText className="paragraph-md text-skin-primary">
                  {studio.Name}, {studio.State}
                </AtText>
                <AtText className="paragraph-md text-skin-primary">
                  {studio.CsPhoneNumber}
                </AtText>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
